var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 22,
    viewBox: "0 0 16 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 18.1333C0.716667 18.1333 0.479167 18.0311 0.2875 17.8267C0.0958333 17.6222 0 17.3689 0 17.0667C0 16.7644 0.0958333 16.5111 0.2875 16.3067C0.479167 16.1022 0.716667 16 1 16H2V8.53333C2 7.05778 2.41667 5.74667 3.25 4.6C4.08333 3.45333 5.16667 2.70222 6.5 2.34667V1.6C6.5 1.15556 6.64583 0.777778 6.9375 0.466667C7.22917 0.155556 7.58333 0 8 0C8.41667 0 8.77083 0.155556 9.0625 0.466667C9.35417 0.777778 9.5 1.15556 9.5 1.6V2.34667C10.8333 2.70222 11.9167 3.45333 12.75 4.6C13.5833 5.74667 14 7.05778 14 8.53333V16H15C15.2833 16 15.5208 16.1022 15.7125 16.3067C15.9042 16.5111 16 16.7644 16 17.0667C16 17.3689 15.9042 17.6222 15.7125 17.8267C15.5208 18.0311 15.2833 18.1333 15 18.1333H1ZM8 21.3333C7.45 21.3333 6.97917 21.1244 6.5875 20.7067C6.19583 20.2889 6 19.7867 6 19.2H10C10 19.7867 9.80417 20.2889 9.4125 20.7067C9.02083 21.1244 8.55 21.3333 8 21.3333ZM4 16H12V8.53333C12 7.36 11.6083 6.35556 10.825 5.52C10.0417 4.68444 9.1 4.26667 8 4.26667C6.9 4.26667 5.95833 4.68444 5.175 5.52C4.39167 6.35556 4 7.36 4 8.53333V16Z",
    fill: "#3C3C3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.49ac0d68249344abc3a0725efd43e32d.svg";
export { ForwardRef as ReactComponent };